// JavaScript code for acf_blocks/booking-corporate-enquiry component
(() => {
    "use strict";

    document.querySelectorAll('[data-enquiry-form-block="corporate"]').forEach((block) => {
        const form = block.querySelector('[data-enquiry-form="corporate"]');

        if (!form) {
            // Confirmation screen.
            const heading = block.querySelector('[data-enquiry-focus]');
            if (heading) heading.focus();
            return;
        }

        const forms     = window.sjmBookingForms;
        const steps     = Array.from(form.querySelectorAll('[data-enquiry-step]'));
        const backLink  = block.querySelector('[data-enquiry-back]');
        const stepLabel = block.querySelector('[data-wizard-step-label]');
        const summary   = block.querySelector('[data-enquiry-error-summary]');
        const total     = steps.length;
        let current     = 1;

        if (forms) forms.clearOnInput(block);

        function showStep(number, moveFocus) {
            current = number;

            steps.forEach((step) => {
                step.hidden = Number(step.dataset.enquiryStep) !== number;
            });

            if (stepLabel) stepLabel.textContent = `Step ${number} of ${total}`;
            block.querySelectorAll('[data-wizard-step-bar]').forEach((bar) => {
                const on = Number(bar.dataset.wizardStepBar) <= number;
                bar.classList.toggle('bg-black/70', on);
                bar.classList.toggle('bg-black/10', !on);
            });

            if (number === total) fillReview();

            if (moveFocus) {
                const heading = form.querySelector(`[data-enquiry-step="${number}"] h1, [data-enquiry-step="${number}"] h2`);
                if (heading) heading.focus();
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                window.scrollTo({ top: Math.max(0, block.getBoundingClientRect().top + window.scrollY - 100), behavior: reduceMotion ? 'auto' : 'smooth' });
            }

            if (window.sjmBookingAnalytics) {
                window.sjmBookingAnalytics.step('enquiry', ['details', 'preferences', 'review'][number - 1], { type: 'corporate' });
            }
        }

        // ---- Live summary and review card ----
        function value(name) {
            const field = form.querySelector(`[name="${name}"]`);
            return field ? field.value.trim() : '';
        }

        function checkedLabels(selector) {
            return Array.from(form.querySelectorAll(`${selector}:checked`)).map((input) => input.dataset.label);
        }

        function refreshSummary() {
            const map = {
                organisation: value('enq_organisation'),
                attendees: value('enq_attendees'),
                delivery: checkedLabels('[name="enq_delivery_location"]')[0] || '',
                timing: value('enq_preferred_timing'),
            };

            Object.entries(map).forEach(([key, text]) => {
                const el = block.querySelector(`[data-enquiry-summary="${key}"]`);
                if (el) el.textContent = text || '—';
            });
        }

        function fillReview() {
            const programmes = checkedLabels('[data-enquiry-programme]');
            const delivery   = (checkedLabels('[name="enq_delivery_location"]')[0] || '').toLowerCase();
            const title      = block.querySelector('[data-enquiry-review-title]');
            const text       = block.querySelector('[data-enquiry-review-text]');
            const timing     = value('enq_preferred_timing');

            if (title) title.textContent = `${programmes[0] || 'Corporate programme'}, ${delivery}`;
            if (text) {
                text.textContent = `${value('enq_attendees') || '?'} people at ${value('enq_organisation') || 'your organisation'}${timing ? ', ' + timing : ''}. This is an enquiry: no date is held until our team confirms.`;
            }
        }

        form.addEventListener('input', refreshSummary);
        form.addEventListener('change', refreshSummary);

        // ---- Industry "Other (please specify)" ----
        const industry      = form.querySelector('[data-enquiry-industry]');
        const industryOther = form.querySelector('[data-enquiry-industry-other]');

        function toggleIndustryOther() {
            if (industry && industryOther) industryOther.hidden = industry.value !== 'other';
        }

        if (industry) industry.addEventListener('change', toggleIndustryOther);
        toggleIndustryOther();

        // ---- "Not sure yet" is exclusive with the named programmes ----
        form.addEventListener('change', (e) => {
            if (!e.target.matches('[data-enquiry-programme]') || !e.target.checked) return;

            const exclusive = e.target.hasAttribute('data-enquiry-exclusive');
            form.querySelectorAll('[data-enquiry-programme]').forEach((input) => {
                if (input !== e.target && (exclusive || input.hasAttribute('data-enquiry-exclusive'))) input.checked = false;
            });
        });

        // ---- Step navigation ----
        form.addEventListener('click', (e) => {
            const next = e.target.closest('[data-enquiry-next]');
            if (!next) return;

            const step         = next.closest('[data-enquiry-step]');
            const firstInvalid = forms ? forms.validate(block, step) : null;

            if (summary) summary.classList.toggle('hidden', !firstInvalid);

            if (firstInvalid) {
                firstInvalid.focus();
                return;
            }

            showStep(current + 1, true);
        });

        if (backLink) {
            backLink.addEventListener('click', (e) => {
                if (current === 1) return; // Step 1's Back leaves for the Corporate page.

                e.preventDefault();
                if (summary) summary.classList.add('hidden');
                showStep(current - 1, true);
            });
        }

        form.addEventListener('submit', (e) => {
            const firstInvalid = forms ? forms.validate(block, form) : null;

            if (firstInvalid) {
                e.preventDefault();
                if (summary) summary.classList.remove('hidden');
                showStep(Number(firstInvalid.closest('[data-enquiry-step]').dataset.enquiryStep), false);
                firstInvalid.focus();
                return;
            }

            const button = form.querySelector('[type="submit"]');
            if (button) button.disabled = true;
        });

        // After a rejected submission, reopen the step holding the first server-side error.
        const serverInvalid = form.querySelector('[aria-invalid="true"]');
        const startStep     = serverInvalid ? Number(serverInvalid.closest('[data-enquiry-step]').dataset.enquiryStep) : 1;

        refreshSummary();
        showStep(startStep, false);

        if (serverInvalid) serverInvalid.focus();
    });
})();
